import { Component } from '@angular/core';

@Component({
  selector: 'app-politica-sgi',
  templateUrl: './politica-sgi.component.html',
  styleUrls: ['./politica-sgi.component.css']
})
export class PoliticaSGIComponent {
  primaryColor = '#0E395F';
}
